import Vue from 'vue';

export function spacList () {
  return Vue.axios({
    url: '/api/parent/spac',
    method: 'get'
  })
}
